import React, { useEffect, useState } from "react";
import { CopyIcon, DoneIcon } from "../Icons";
import './index.css'

interface CopyToClipboardProps {
  targetText: string
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ targetText }) => {
  const [itemCopied, setItemCopied] = useState<boolean>(false)

  useEffect(() => {
    if (itemCopied) {
      setTimeout(() => { setItemCopied(false) }, 1000)
    }
  }, [itemCopied])

  const handleCopy = async () => {
    try {
      if (targetText) {
        await navigator.clipboard.writeText(targetText);
        setItemCopied(true)
      }
    } catch (error) {
      console.error("Error al copiar al portapapeles:", error);
    }
  };

  return (
    <div className="copy-clipboard-container">
      {(!itemCopied) && (
        <CopyIcon className="copy-clipboard-copy-icon" onClick={handleCopy} />
      )}
      {(itemCopied) && (
        <DoneIcon className="copy-clipboard-done-icon" />
      )}
    </div>
  );
};

export default CopyToClipboard;
